import axios from "axios"
const token = localStorage.getItem("user-token");
const Axios = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    authorization: `bearer ${token}`,
  },
});

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user-token"); // <-- удаляем токен
      window.location = "/"; // <-- редирект на главную
    } else {
      return Promise.reject(error); // <-- не забываем возвращать ошибку для дальнейшей обработки
    }
  }
);

export default {
  Axios,
}
